const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

const CONFIG = {
    API_BASE_URL: isLocal
        ? "http://loyiha/public/api"
        : "https://suvoriy.com/api",
    DOMAIN: isLocal
        ? `http://${window.location.host}`
        : "https://suvoriy.com"
};

export default CONFIG;
